import { IconInfoCircle } from '@tabler/icons-react'

import Link from 'shared/ui/Link/Link'
import { PATHS } from 'shared/utils/paths'
import { addTestId } from 'shared/utils/tests'

import styles from './SearchDropdownNoResults.module.scss'

const SearchDropdownNoResults = ({ query }: { query: string }) => {
  return (
    <div className={styles.wrapper}>
      <h3 className={styles.title} {...addTestId('search-no-results-title')}>
        Nie znaleźliśmy produktów dla frazy: <br />
        <strong>&quot;{query}&quot;</strong>.
      </h3>
      <ul className={styles.description} {...addTestId('search-no-results-description')}>
        <li>Upewnij się, że wpisana fraza jest poprawna.</li>
        <li>Zmień słowa kluczowe na bardziej ogólne.</li>
        <li>
          Odkrywaj produkty przeglądając nasze{' '}
          <Link href={PATHS.categories} variant='inherit'>
            kategorie
          </Link>
          .
        </li>
      </ul>
      <div className={styles.suggestProduct} {...addTestId('search-no-results-contact')}>
        <IconInfoCircle
          style={{ flexShrink: 0, color: 'var(--color-brand-primary)' }}
          size={48}
          stroke={1.5}
        />
        <div>
          Nie możesz znaleźć ulubionego produktu? <br />{' '}
          <a href='mailto:bok@lokalnyrolnik.pl'>Napisz do nas!</a>
        </div>
      </div>
    </div>
  )
}

export default SearchDropdownNoResults
